/* eslint camelcase: "off" */
import { init_as_module } from './mixpanel-core';

var mixpanel = init_as_module();

export default mixpanel;
